import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import "./App.css";
import "./CustomStyle.css";

import Login from "./Pages/Login/Login";
import Unauthorized from "./Pages/Unauthorized/Unauthorized";

import Users from "./Pages/Users/Users";
import AddUsers from "./Pages/Users/AddUsers";
import EditUsers from "./Pages/Users/EditUsers";

import QueuedPatients from "./Pages/QueuedPatients/QueuedPatients";

import FollowUpPatients from "./Pages/FollowUpPatients/FollowUpPatients";

import FollowUpTomorrow from "./Pages/FollowUpTomorrow/FollowUpTomorrow";

import DailyLogs from "./Pages/Report/DailyLogs";
import ResidentsReport from "./Pages/Report/ResidentsReport";
import OutpatientVisits from "./Pages/Report/OutpatientVisits";
import Prescription from "./Pages/Prescription/Prescription";
import CreatePrescription from "./Pages/Prescription/CreatePrescription";
import AddPatient from "./Components/Patients/AddPatient";
import EditPatient from "./Components/Patients/EditPatient";
import PatientProfile from "./Components/PatientProfile/PatientProfile";
import PatientManager from "./Components/Patients/PatientManager";
import MedicalCertificate from "./Components/Forms/MedicalCertificate/MedicalCertificate";
import MedicalAbstract from "./Components/Forms/MedicalAbstract/MedicalAbstract";
import AssessmentHistory from "./Components/AssessmentHistory/AssessmentHistory";
import MedicalHistory from "./Components/MedicalHistory/MedicalHistory";
import AddVitalSigns from "./Components/MedicalHistory/AddVitalSigns";
import AddMedical from "./Components/MedicalHistory/AddMedical";
import CheckUp from "./Components/Forms/CheckUp/CheckUp";
import AdmissionForm from "./Components/Forms/AdmissionForm/AdmissionForm";
import Diagnosis from "./Components/Diagnosis/Diagnosis";
import OutPatient from "./Components/Forms/OutPatient/OutPatient";
import VaccinationForm from "./Components/VaccinationForm/VaccinationForm";
import CensusOfDiseases from "./Pages/Report/CensusOfDiseases";
import ViewCensusOfDiseases from "./Pages/Report/ViewCensusOfDiseases";
import Dashboard from "./Pages/Dashboard-screen/Dashboard_screen";
import CheckupTabs from "./Pages/CheckupTabs/CheckupTabs";
import ListOfSales from "./Pages/Pharmacy/ListOfSales";
import Inventories from "./Pages/Pharmacy/Inventories";
import InventoryLogs from "./Pages/Pharmacy/InventoryLogs";
import AddEditInventories from "./Pages/Pharmacy/AddEditInventories";
import NewPatientVitalSigns from "./Components/Patients/NewPatientVitalSigns";
import Letterhead from "./Pages/Report/Letterhead";
import DiagnosisVer2 from "./Components/Diagnosis/DiagnosticsVer2";
// import ChatComponent from "./Components/ChatComponent/ChatComponent";
import { ToastContainer } from "react-toastify";
import EditPrescription from "./Pages/Prescription/EditPrescription";
import { getToken, getRole } from "./Components/Helpers/Utilities/Common";
import FPE from "./Components/Forms/FPE/FPE";
import IsRegisteredCheck from "./Pages/PhilHealth/IsRegisteredCheck";
import ConsultPatientSearch from "./Pages/Consult/ConsultPatientSearch";

function App() {
  const [token, setToken] = useState(getToken());
  const role = getRole();

  useEffect(() => {
    setToken(getToken());
  }, []);

  return (
    <>
      <ToastContainer
        hideProgressBar
        style={{ textTransform: "capitalize" }}
        toastStyle={{ fontFamily: "Rubik-Regular" }}
        autoClose={2000}
      />
      {/* {
        token && (
          <ChatComponent/>
        )
      } */}
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />

          <Route path="/login" element={token ? <Dashboard /> : <Login />} />
          <Route
            path="/dashboard"
            element={
              token ? (
                role === "director" ||
                role === "pcp" ||
                role === "specialist" ||
                role === "nurse" ? (
                  <Dashboard />
                ) : (
                  <Unauthorized />
                )
              ) : (
                <Login />
              )
            }
          />

          {/* User Module */}
          <Route
            path="/users"
            element={
              token ? (
                role === "director" || role === "pcp" || role === "specialist" ? (
                  <Users />
                ) : (
                  <Unauthorized />
                )
              ) : (
                <Login />
              )
            }
          />

          <Route
            path="/users/add"
            element={
              token ? (
                role === "director" || role === "pcp" || role === "specialist" ? (
                  <AddUsers />
                ) : (
                  <Unauthorized />
                )
              ) : (
                <Login />
              )
            }
          />

          <Route
            path="/users/edit/:id"
            element={
              token ? (
                role === "director" || role === "pcp" || role === "specialist" ? (
                  <EditUsers />
                ) : (
                  <Unauthorized />
                )
              ) : (
                <Login />
              )
            }
          />

          {/* Queue Patients Module */}
          <Route
            path="/queue"
            element={
              token ? (
                role === "director" ||
                role === "pcp" ||
                role === "specialist" ||
                role === "nurse" ? (
                  <QueuedPatients />
                ) : (
                  <Unauthorized />
                )
              ) : (
                <Login />
              )
            }
          />

          {/* List of Sales Module */}
          {/* <Route
            path="/list-of-sales"
            element={token ? <ListOfSales /> : <Login />}
          /> */}

          {/* Inventory Logs*/}
          <Route
            path="/inventory-logs"
            element={
              token ? (
                role === "director" ||
                role === "pcp" ||
                role === "specialist" ||
                role === "nurse" ? (
                  <InventoryLogs />
                ) : (
                  <Unauthorized />
                )
              ) : (
                <Login />
              )
            }
          />

          {/* Inventories Module */}
          <Route
            path="/inventories"
            element={
              token ? (
                role === "director" ||
                role === "pcp" ||
                role === "specialist" ||
                role === "nurse" ? (
                  <Inventories />
                ) : (
                  <Unauthorized />
                )
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/add-inventory"
            element={
              token ? (
                role === "director" ||
                role === "pcp" ||
                role === "specialist" ||
                role === "nurse" ? (
                  <AddEditInventories />
                ) : (
                  <Unauthorized />
                )
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/edit-inventory/:id"
            element={
              token ? (
                role === "director" ||
                role === "pcp" ||
                role === "specialist" ||
                role === "nurse" ? (
                  <AddEditInventories />
                ) : (
                  <Unauthorized />
                )
              ) : (
                <Login />
              )
            }
          />

          {/* Follow Up Patients for Tomorrow Module */}
          <Route
            path="/follow-up-patients"
            element={
              token ? (
                role === "director" ||
                role === "pcp" ||
                role === "specialist" ||
                role === "nurse" ? (
                  <FollowUpPatients />
                ) : (
                  <Unauthorized />
                )
              ) : (
                <Login />
              )
            }
          />

          {/* Follow Up Patients Module */}
          <Route
            path="/follow-up-tomorrow"
            element={
              token ? (
                role === "director" ||
                role === "pcp" ||
                role === "specialist" ||
                role === "nurse" ? (
                  <FollowUpTomorrow />
                ) : (
                  <Unauthorized />
                )
              ) : (
                <Login />
              )
            }
          />

          {/* Checkup Tabs */}
          <Route
            path="/checkup/tabs/:id/:tab"
            element={token ? <CheckupTabs /> : <Unauthorized />}
          />

          {/* Reports Module */}
          <Route
            path="/professional-fee"
            element={
              token ? (
                role === "director" ||
                role === "pcp" ||
                role === "specialist" ||
                role === "nurse" ? (
                  <DailyLogs />
                ) : (
                  <Unauthorized />
                )
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/census-of-diseases"
            element={
              token ? (
                role === "director" ||
                role === "pcp" ||
                role === "specialist" ||
                role === "nurse" ? (
                  <CensusOfDiseases />
                ) : (
                  <Unauthorized />
                )
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/census-of-diseases/view/:diagnosis"
            element={
              token ? (
                role === "director" ||
                role === "pcp" ||
                role === "specialist" ||
                role === "nurse" ? (
                  <ViewCensusOfDiseases />
                ) : (
                  <Unauthorized />
                )
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/resident-reports"
            element={
              token ? (
                role === "director" ||
                role === "pcp" ||
                role === "specialist" ||
                role === "nurse" ? (
                  <ResidentsReport />
                ) : (
                  <Unauthorized />
                )
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/outpatient-visits"
            element={
              token ? (
                role === "director" ||
                role === "pcp" ||
                role === "specialist" ||
                role === "nurse" ? (
                  <OutpatientVisits />
                ) : (
                  <Unauthorized />
                )
              ) : (
                <Login />
              )
            }
          />

          {/* Prescription Module */}
          <Route
            path="/prescription"
            element={
              token ? (
                role === "director" ||
                role === "pcp" ||
                role === "specialist" ||
                role === "nurse" ? (
                  <Prescription />
                ) : (
                  <Unauthorized />
                )
              ) : (
                <Login />
              )
            }
          />

          {/* <Route
            path="/create-prescription"
            element={token ? <CreatePrescription /> : <Unauthorized />}
          />
          <Route
            path="/edit-prescription"
            element={token ? <EditPrescription /> : <Unauthorized />}
          /> */}

          {/* Assessment History */}
          <Route
            path="/assessment-history"
            element={token ? <AssessmentHistory /> : <Login />}
          />

          {/* Diagnosis Form */}
          <Route
            path="/diagnosis/:id"
            element={token ? <DiagnosisVer2 /> : <Login />}
          />

          {/* Medical History */}
          <Route
            path="/medical-history"
            element={token ? <MedicalHistory /> : <Login />}
          />
          <Route
            path="/add-vital-signs"
            element={token ? <AddVitalSigns /> : <Login />}
          />
          <Route
            path="/add-medical"
            element={token ? <AddMedical /> : <Login />}
          />

          {/* patient profile */}
          <Route
            path="/patients"
            element={token ? <PatientManager /> : <Login />}
          />
          <Route
            path="/consult/select-patient"
            element={
              token ? (
                role === "director" ||
                role === "pcp" ||
                role === "specialist" ||
                role === "nurse" ? (
                  <ConsultPatientSearch />
                ) : (
                  <Unauthorized />
                )
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/patients/add/:type"
            element={token ? <AddPatient /> : <Login />}
          />
          <Route
            path="/patients/edit/:id"
            element={token ? <EditPatient /> : <Login />}
          />
          <Route
            path="/philhealth/is-registered"
            element={
              token ? (
                role === "director" ||
                role === "pcp" ||
                role === "specialist" ||
                role === "nurse" ? (
                  <IsRegisteredCheck />
                ) : (
                  <Unauthorized />
                )
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/patients/vitals/:id"
            element={token ? <NewPatientVitalSigns /> : <Login />}
          />
          <Route
            path="/patients/fpe/:id"
            element={token ? <FPE /> : <Login />}
          />
          <Route
            path="/patients/profile/:id"
            element={token ? <PatientProfile /> : <Login />}
          />

          {/* Diagnosis Form */}
          <Route
            path="/diagnosis/:id"
            element={token ? <Diagnosis /> : <Login />}
          />

          {/* Out Patient Form */}
          <Route
            path="/out-patient/:id"
            element={token ? <OutPatient /> : <Login />}
          />

          <Route
            path="/letterhead"
            element={token ? <Letterhead /> : <Login />}
          />

          {/* check up form */}
          <Route
            path="/checkup/:id"
            element={token ? <CheckUp /> : <Login />}
          />
          {/* admission form */}
          <Route
            path="/admission/:id"
            element={token ? <AdmissionForm /> : <Login />}
          />

          {/*medical certificate*/}
          <Route
            path="/medical-cert"
            element={token ? <MedicalCertificate /> : <Login />}
          />
          {/* medical abstract */}
          <Route
            path="/medical-abstract"
            element={token ? <MedicalAbstract /> : <Login />}
          />

          {/*vaccination form*/}
          <Route
            path="/add-vaccination"
            element={token ? <VaccinationForm /> : <Login />}
          />
        </Routes>
      </Router>
    </>
  );
}

export default App;
